import { vars } from '@etg/wings';
import { css, cx } from '@eti/styles';
import { UI } from 'react-day-picker';

const getReturnTripBgColor = (
  isReturnTrip: boolean,
  isSameDayReturnTrip: boolean,
  isOnlyDepartureSelected: boolean,
) => {
  if (!isReturnTrip || isSameDayReturnTrip || isOnlyDepartureSelected) {
    return 'transparent';
  }

  return vars.colors.calendar.date.range;
};

export const calendarStyles = (
  isRevolut: boolean,
  isReturnTrip: boolean,
  isSameDayReturnTrip: boolean,
  isOnlyDepartureSelected: boolean,
  shouldShowCustomNonPriceCalendar: boolean,
) => ({
  [UI.Root]: 'rdp-root',
  [UI.CaptionLabel]: css`
    align-self: center;
    color: ${vars.colors.text.primary};
    flex: 1;
    font-size: ${isRevolut ? '1rem' : '0.875rem'};
    font-weight: 500;
    text-align: center;
  `,
  [UI.Nav]: css`
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 100%;
  `,
  [UI.MonthGrid]: css`
    border-collapse: separate;
    border-spacing: ${isRevolut ? '0 0.5rem' : '0.25rem'};
    margin-top: 0.5rem;
    width: 100%;
  `,
  [UI.Months]: css`
    width: 100%;
  `,
  [UI.Weekday]: css`
    font-weight: 400;
    padding-bottom: 0.25rem;
    text-transform: unset;
  `,
  [UI.Day]: cx(
    'notranslate',
    'rdp-day',
    css`
      padding: 0;
      position: relative;
    `,
    isRevolut &&
      css`
        &.rdp-range_start,
        &.rdp-range_end {
          background: none;
        }

        &.rdp-in-range::before,
        &.rdp-masked::before {
          background: ${vars.colors.calendar.date.range};
          content: '';
          inset: 0 -1px;
          position: absolute;
          z-index: 0;
        }

        &.rdp-selected::before {
          background: ${isRevolut
            ? getReturnTripBgColor(isReturnTrip, isSameDayReturnTrip, isOnlyDepartureSelected)
            : vars.colors.inputs.main};
          content: '';
          inset: 0 -1px;
          position: absolute;
          z-index: 0;
        }

        &.rdp-range_start::before {
          border-bottom-left-radius: ${vars.card.borderRadius};
          border-top-left-radius: ${vars.card.borderRadius};
          left: 0;
        }

        &.rdp-range_end::before {
          border-bottom-right-radius: ${vars.card.borderRadius};
          border-top-right-radius: ${vars.card.borderRadius};
          right: 0;
        }
      `,
    shouldShowCustomNonPriceCalendar &&
      css`
        &.rdp-day {
          height: 32px;
        }
      `,
  ),
  [UI.DayButton]: css`
    appearance: none;
    background-color: transparent;
    border: none;
    border-radius: ${isRevolut && isReturnTrip ? 0 : '0.1875rem'};
    font-size: 0.875rem;
    height: 100%;
    position: relative;
    -webkit-tap-highlight-color: transparent;
    width: 100%;

    .rdp-selected && {
      ${!isRevolut && `background-color: ${vars.colors.calendar.date.selected}`};
      color: ${vars.colors.text.inverse};

      ${isRevolut
        ? `
      & > div:first-child {
        background-color: ${vars.colors.focusRing};
        border-radius: ${vars.card.borderRadius};
      }`
        : ''}
    }

    .rdp-masked &&,
    .rdp-in-range && {
      background-color: ${!isRevolut ? vars.colors.calendar.date.range : 'transparent'};
    }

    ${isRevolut
      ? `
    .rdp-range_start && {
      border-top-left-radius: ${vars.card.borderRadius};
      border-bottom-left-radius: ${vars.card.borderRadius};
    }

    .rdp-range_end && {
      border-top-right-radius: ${vars.card.borderRadius};
      border-bottom-right-radius: ${vars.card.borderRadius};
    }`
      : ''}

    &:hover {
      ${!isRevolut && `background-color: ${vars.colors.inputs.hover}`};
      cursor: pointer;
    }

    &[disabled] {
      color: ${vars.colors.text.secondary};
      cursor: auto;
      opacity: 1;
    }

    &[disabled]:hover {
      background-color: unset;
    }

    &:focus-visible {
      background-color: ${vars.colors.inputs.hover};
      outline: 0.125rem solid ${vars.colors.focusRing};
      outline-offset: 0.0625rem;
    }
  `,
  [UI.Week]: cx(
    'rdp-week',
    isRevolut &&
      css`
        & .rdp-masked.rdp-is-last-day-of-month.rdp-day::before,
        & .rdp-selected.rdp-is-last-day-of-month.rdp-day::before,
        & .rdp-selected.rdp-day:last-child::before,
        & .rdp-masked.rdp-day:last-child::before {
          border-bottom-right-radius: ${vars.card.borderRadius};
          border-top-right-radius: ${vars.card.borderRadius};
        }

        & .rdp-masked.rdp-is-first-day-of-month.rdp-day::before,
        & .rdp-selected.rdp-is-first-day-of-month.rdp-day::before,
        & .rdp-masked:first-child.rdp-day::before,
        & .rdp-selected:first-child.rdp-day::before {
          border-bottom-left-radius: ${vars.card.borderRadius};
          border-top-left-radius: ${vars.card.borderRadius};
        }
      `,
  ),
});
